module.exports = __webpack_public_path__ + "img/zoom-addin-04.637bd520.png";